import React from 'react';

const AboutHero = () => {
  return (
    <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden bg-gradient-to-br from-gray-50 to-white pt-32 pb-20">
      {/* Background Pattern */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-[#005B63]/5 to-transparent" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#005B63]/5 rounded-full blur-3xl -translate-x-1/2 translate-y-1/2" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl">
          {/* Label */}
          <div className="inline-flex items-center px-4 py-2 bg-[#005B63]/10 rounded-full text-[#005B63] text-sm font-medium mb-6">
            About Us
          </div>

          {/* Main heading */}
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-gray-900 mb-8 leading-tight">
            We are{' '}
            <span className="text-[#005B63]">Integrand Analytics</span>
            <span className="block mt-2">
              Your trusted CRE{' '}
              <span className="text-[#005B63]">outsourcing</span>{' '}
              partner
            </span>
          </h1>

          {/* Description */}
          <p className="text-gray-600 text-lg sm:text-xl leading-relaxed max-w-3xl">
            An independent capital market advisory and financial analytics firm that provides knowledge process outsourcing (KPO) services to the commercial real estate industry. We work as an extension of your business, making you agile.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;
